export default __webpack_public_path__ + "static/media/icon-instagram.b94ff26a.svg";